import { TableRow } from '@shared/UI';

interface Options {
    onClientViewClick: (client: any) => void;
}

export function getClientTableRows(options: Options): TableRow<any> {
    const { onClientViewClick } = options;
    return {
        onClick: (row) => () => onClientViewClick(row),
    };
}
